var map = {
	"./cloud-1.png": 8627,
	"./cloud-2.png": 296,
	"./cloud-3.png": 8689,
	"./cloud-4.png": 4126,
	"./container-bg.png": 9139,
	"./container-gradient.png": 9642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8439;